// eslint-disable-next-line no-unused-vars
import { h, Component, Fragment } from 'preact';
import PropTypes from 'prop-types';
import { useState } from 'preact/hooks';
import { isActiveLink } from '../../utils';
import { navigationItemPropType, venuePropType } from '../../propTypes';
import PrimaryNavigationMenuItemMobile from '../PrimaryNavigationMenuItemMobile';
import { NavigationMenuItem, MenuList, MenuChildren } from './styles';
import MenuWrapper from '../MenuWrapper';

const PrimaryNavigationMenuMobile = ({
  items,
  sitePrimaryColor,
  primaryNavigationButton,
  includeTicketsButton,
  includeShopButton,
  open,
  allowForSecondaryNav,
  alternate,
  venues,
}) => {
  const [parentItem, setParentItem] = useState(undefined);
  const [children, setChildren] = useState([]);
  const subMenuOpen = children.length > 0;

  const onMenuReturn = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    if (item.return) {
      setParentItem(undefined);
      setChildren([]);
    }
  };

  const onMenuClick = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    if (!item.children) {
      return;
    }
    const selectedItem = { ...item };
    selectedItem.return = true;
    selectedItem.backgroundColor = undefined;

    const selectedMenuItemChildren = [...item.children];
    setParentItem(selectedItem);
    setChildren(selectedMenuItemChildren);
  };

  return (
    <MenuWrapper id="nav-menu" role="menu" right open={open} topSpace={allowForSecondaryNav} alternate={alternate}>
      <MenuList>
        {!subMenuOpen && (
          <div>
            {items && items.map(item => (
              <NavigationMenuItem
                href={item.link}
                item={item}
                active={isActiveLink(item.link)}
                alternate={alternate}
              >
                <PrimaryNavigationMenuItemMobile
                  sitePrimaryColor={sitePrimaryColor}
                  onMenuClick={e => onMenuClick(e, item)}
                  onMenuReturn={e => onMenuReturn(e, item)}
                  item={item}
                  alternate={alternate}
                />
              </NavigationMenuItem>
            ))}
          </div>
        )}
        {subMenuOpen && (
          <MenuChildren>
            {parentItem && (
              <NavigationMenuItem
                onClick={e => onMenuReturn(e, parentItem)}
                href={parentItem.link}
                item={parentItem}
                key={parentItem}
                active={isActiveLink(parentItem.link)}
              >
                <PrimaryNavigationMenuItemMobile
                  sitePrimaryColor={sitePrimaryColor}
                  item={parentItem}
                />
              </NavigationMenuItem>
            )}
            {children.map(item => (
              <NavigationMenuItem
                href={item.link}
                item={item.link}
                key={item}
                active={isActiveLink(item.link)}
              >
                <PrimaryNavigationMenuItemMobile
                  sitePrimaryColor={sitePrimaryColor}
                  onMenuClick={e => onMenuClick(e, item)}
                  onMenuReturn={e => onMenuReturn(e, item)}
                  item={item}
                />
              </NavigationMenuItem>
            ))}
            {parentItem?.additionalItems && parentItem.additionalItems.map(item => (
              <NavigationMenuItem href={item.link} item={item} active={isActiveLink(item.link)}>
                <PrimaryNavigationMenuItemMobile
                  sitePrimaryColor={sitePrimaryColor}
                  onMenuClick={e => onMenuClick(e, item)}
                  onMenuReturn={e => onMenuReturn(e, item)}
                  item={item}
                />
              </NavigationMenuItem>
            ))}
          </MenuChildren>
        )}
        {(primaryNavigationButton && !subMenuOpen) && (
          <NavigationMenuItem
            href={primaryNavigationButton.link || null}
            item={primaryNavigationButton}
          >
            <PrimaryNavigationMenuItemMobile
              onMenuClick={e => onMenuClick(e, primaryNavigationButton)}
              sitePrimaryColor={sitePrimaryColor}
              item={primaryNavigationButton}
            />
          </NavigationMenuItem>
        )}
        {!subMenuOpen && (
          <Fragment>
            {includeTicketsButton && (
            <Fragment>
              <NavigationMenuItem
                href="/tickets"
                item={{ backgroundColor: '#4ecef7', hoverBackgroundColor: '#1292cc' }}
              >
                <PrimaryNavigationMenuItemMobile item={{ title: 'Tickets', textColor: '#000' }} />
              </NavigationMenuItem>
              {venues.length > 0
              && venues.map(venue => (
                <NavigationMenuItem
                  href={venue.url}
                  key={venue.name}
                  alternate={alternate}
                >
                  <PrimaryNavigationMenuItemMobile
                    item={{
                      title: venue.name,
                      textColor: '#1292cc',
                      children: venue.name,
                      borderColor: '#1292cc',
                      borderWidth: '1px',
                      arrowAlternate: true,
                    }}
                    alternate={alternate}
                  />
                </NavigationMenuItem>
              ))}
            </Fragment>
            )}
            { includeShopButton && (
              <NavigationMenuItem href="https://shop.spyscape.com">
                <PrimaryNavigationMenuItemMobile item={{ title: 'Shop' }} />
              </NavigationMenuItem>
            )}
          </Fragment>
        )}
      </MenuList>
    </MenuWrapper>
  );
};

PrimaryNavigationMenuMobile.propTypes = {
  items: PropTypes.arrayOf(navigationItemPropType),
  primaryNavigationButton: navigationItemPropType,
  sitePrimaryColor: PropTypes.string,
  includeTicketsButton: PropTypes.bool.isRequired,
  includeShopButton: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  allowForSecondaryNav: PropTypes.bool.isRequired,
  alternate: PropTypes.bool,
  venues: venuePropType,
};

PrimaryNavigationMenuMobile.defaultProps = {
  items: [],
  primaryNavigationButton: null,
  sitePrimaryColor: '',
  alternate: false,
  venues: [],
};

export default PrimaryNavigationMenuMobile;
